import cn from "classnames";
import React from "react";
import { Home } from "react-feather";
import { BiCog, BiTransfer } from "react-icons/bi";
import { FiLogOut } from "react-icons/fi";
import { MdAccountBalanceWallet } from "react-icons/md";
import { LinkProps, NavLink } from "react-router-dom";
import logoImage from "../../../../assets/images/logo.svg";
import * as r from "../../../../routes";

const SIDE_NAV_LINK_ICON_SIZE = 22;

const SideNav = () => {
  return (
    <div className="w-24 flex-none h-full bg-gray-100 flex flex-col items-center">
      <img
        className="mt-8"
        src={logoImage}
        alt="Due Logo"
        style={{ height: 24 }}
      />

      <SideNavLink
        to={r.ROUTE_HOME}
        className="mt-8 mb-4"
        icon={<Home size={SIDE_NAV_LINK_ICON_SIZE} />}
      />
      <SideNavLink
        to={r.ROUTE_TRANSACTIONS}
        className="mb-4"
        icon={<BiTransfer size={SIDE_NAV_LINK_ICON_SIZE} />}
      />
      <SideNavLink
        to={r.ROUTE_ACCOUNTS}
        className="mb-4"
        icon={<MdAccountBalanceWallet size={SIDE_NAV_LINK_ICON_SIZE} />}
      />

      <div className="mt-auto">
        <SideNavLink
          to={r.ROUTE_SETTINGS}
          className="mb-4"
          icon={<BiCog size={SIDE_NAV_LINK_ICON_SIZE} />}
        />
        <SideNavLink
          to={r.ROUTE_SETTINGS}
          className="mb-4"
          icon={<FiLogOut size={SIDE_NAV_LINK_ICON_SIZE} />}
        />
      </div>
      {/* <SideNavLink to="/" icon={<Home size={22} />} />
      <SideNavLink to="/" icon={<Home size={22} />} /> */}
    </div>
  );
};

export default SideNav;

const SideNavLink = ({
  className,
  icon,
  ...props
}: LinkProps & { icon: React.ReactNode }) => {
  return (
    <NavLink
      className={cn(
        "w-12 h-12 rounded-xl bg-gray-300",
        "text-white transition-all",
        "flex items-center justify-center",
        "outline-none focus:outline-none focus:ring ring-gray-300 ring-opacity-40",
        "hover:border-primary hover:ring",
        className
      )}
      activeClassName="bg-primary ring-primary"
      {...props}
    >
      {icon}
    </NavLink>
  );
};
